// Share counts-only queries across the product and policy surfaces. Credentials
// stay outside cache keys; a new authenticated session gets a new opaque epoch.
import { statisticsSession } from './statisticsQueries';
export function contentUsageScope(environment, token, userId, role) {
  return [environment, String(userId ?? 'session'), role ?? 'unknown', statisticsSession(token)];
}
export const contentUsageKeys = {
  policy: scope => ['contentUsage', 'policy', ...scope],
  metrics: (scope, days) => ['contentUsage', 'metrics', days, ...scope],
  audits: scope => ['contentUsage', 'audits', ...scope],
};
// Retry only the explicit transient configuration failure, once.
export function retryContentUsageRead(failureCount, error) {
  return failureCount < 1 && error?.status === 500 && error?.code === -500;
}
export const CONTENT_USAGE_READ_OPTIONS = { retry: retryContentUsageRead, retryDelay: 1000 };
export const CONTENT_USAGE_METRICS_OPTIONS = { ...CONTENT_USAGE_READ_OPTIONS, staleTime: 15 * 60 * 1000, gcTime: 30 * 60 * 1000, refetchOnWindowFocus: false };
